import { isEmpty } from 'lodash/fp';

import { CommonQuestions } from '../../../../../types/__codegen__/sanity/graphql';
import { CONTENT_SECTIONS } from '../../../content/sections';
import getFormattedQuestionForAccordion from '../../../../../utils/get-formatted-question-for-accordion';

type Props = {
  cmsSectionContent: CommonQuestions & {
    orderIndex: number;
  };
};

const mapQuestionsContent = ({ cmsSectionContent }: Props) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  return {
    items: getFormattedQuestionForAccordion(cmsSectionContent.questions),
    orderIndex: cmsSectionContent.orderIndex,
    type: CONTENT_SECTIONS.COMMON_QUESTIONS,
  };
};

export default mapQuestionsContent;
